import * as React from 'react';

import BaseLocationListLayout from './BaseLocationListLayout';
import LocationCreatePopup from '../containers/locations/LocationCreatePopup';

export default function (params) {
  return BaseLocationListLayout(
    <LocationCreatePopup />
  );
};
